/* eslint-disable camelcase */

import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export default {
  getExperience(partner, id) {
    return fetch(getUrl(`/partners/${partner}/experiences/${id}`), { skipAuthRedirect: true });
  },
  getFoxForesightCharts: () => fetch(getUrl('/partners/sportsgold/charts'), { skipAuthRedirect: true }),
  getFoxForesightGames: (date) => fetch(getUrl(`/partners/sportsgold/games?day=${date}`), { skipAuthRedirect: true }),
  getFoxForesightChartOptions: (chartType, gameId) => fetch(getUrl(`/partners/sportsgold/charts/${chartType}/options?game_id=${gameId}`), { skipAuthRedirect: true }),
};
